// Intención post-autenticación: recuerda a dónde quería ir el usuario antes
// de pasar por el registro/login, para retomarlo al completar el acceso.
//
// Journeys soportados:
//   { type: 'premium_checkout' }      → tras llegar a /profile se lanza el
//                                       Stripe Checkout de Troly Premium.
//   { type: 'listing', id: '<_id>' }  → tras autenticarse se navega de vuelta
//                                       a /listing/<_id>.
//
// Se usa localStorage (no sessionStorage) porque el registro por invitación
// puede continuar en otra pestaña (enlace del correo con el código). El TTL
// evita que una intención vieja dispare un checkout inesperado semanas después.

const KEY = 'troly_post_auth_intent';
const TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 días: margen para el código por correo

export function setPostAuthIntent(intent) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...intent, exp: Date.now() + TTL_MS }));
  } catch { /* modo privado / storage lleno: el flujo sigue sin redirección */ }
}

function readIntent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const intent = JSON.parse(raw);
    if (!intent?.type || !intent.exp || Date.now() > intent.exp) {
      localStorage.removeItem(KEY);
      return null;
    }
    return intent;
  } catch {
    return null;
  }
}

export function clearPostAuthIntent() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
const clearIntent = clearPostAuthIntent;

// Ruta a la que navegar justo después de login/registro. La intención de
// listing se consume aquí; la de premium_checkout se deja guardada para que
// /profile la consuma y lance Stripe (el journey pasa por el perfil).
export function consumePostAuthDestination() {
  const intent = readIntent();
  if (intent?.type === 'listing' && intent.id) {
    clearIntent();
    return `/listing/${intent.id}`;
  }
  return '/profile';
}

// Consumida por /profile: true si hay una intención pendiente de ir al
// checkout de Troly Premium. Se limpia siempre (one-shot).
export function consumePremiumCheckoutIntent() {
  const intent = readIntent();
  if (intent?.type !== 'premium_checkout') return false;
  clearIntent();
  return true;
}
